import React, { Component, useState, useEffect  } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import queryString from 'query-string';
import { saveAs } from 'file-saver';
/*
import useWebInstallPrompt from '../hooks/useWebInstallPrompt';
*/







function Msme (props) {
	//&id=14&tv=123916995
let customspremurl='https://customsprem.gov.tc/';
let resturl='https://customsprem.gov.tc/';

const queryStringParams = queryString.parse(window.location.search);
if (queryStringParams.drv!=undefined){
	resturl='http://127.0.0.1:3001/';
	customspremurl='http://127.0.0.1:3001/';
	console.log('resturl: '+resturl);
	//console.log('queryStringParams: '+resturlJSON.stringify(queryStringParams));
	}//end if


const [dowait, setDowait] = useState({show:false});
const [msmecpcs, setMsmecpcs] = useState([]);
const [crit, setCrit] = useState({
cpc:''
, date1: new Date().toISOString().slice(0, 10)
, date2: new Date().toISOString().slice(0, 10)
});	
//, needpwd: false


useEffect(() => {
	document.title =   "TCI Customs Msme";	
	
	document.getElementsByTagName('body')[0].classList.add("loginbody");
	getmsmecpcs();
//window.dispatchEvent(event)
},[]);











const navigate = useNavigate();	


async function getmsmecpcs(){
		
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };	
  
  setDowait({show:true});
  
  await  fetch(resturl+'rarawxlreport/getmsmecpcs',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetmsmecpcs(res)  )
      .catch(err => console.log(err));
	  
}//end func


async function aftergetmsmecpcs(res){
	 setDowait({show:false});
	 
	 
let temp=[];
res.map((col, index) => {
	const key="cpccodes_"+index;
	const cpc=col['CPC'];
	
	//console.log('afterfetchctrycodes nam: '+nam);
	
	temp.push(<option key={key+"_cod"} value={col['RUL_COD']} >{cpc}</option>);
	
	});//end map

setMsmecpcs(temp);
	 
	 
}//end func
	
async function submitform1(e){
	e.preventDefault();
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };	
  
  //document.getElementById("btnexcel").style.visibility="hidden";
  setDowait({show:true});
  
  await  fetch(resturl+'rarawxlreport/getxlfilename',requestOptions)
      .then(res => res.json())
      .then(res => 	rptmsmevalxml(res)  )
      .catch(err => console.log(err));
	  
}//end func


async function rptmsmevalxml(res){
//rptmsmevalxml filename
let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="TCI_CUSTOMS_MSME_"+res[0].FILE_NAME;


const params={
	username:sessionStorage.getItem("EMAIL")
	,rul_cod:crit.cpc
	,date1:crit.date1
	,date2:crit.date2
	,filename:FILE_NAME
	};

console.log("params: "+JSON.stringify(params));

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };

//.then(res => res.json())
	  await fetch(customspremurl+'rarawxlreport/rptmsmevalxml',requestOptions)
		  .then(res => afterrptmsmevalxml(res, FILE_NAME))
		  .catch(err => console.log(err));
		  
}//end func

async function afterrptmsmevalxml(res, FILE_NAME){
	
	setDowait({show:false});
		const pBlob = await res.blob();
	var blob = new Blob([pBlob], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
saveAs(blob, FILE_NAME+".xlsx");


}//end func




function handleChange(e){
	
const {name,value}= e.target;
console.log("handleChange: "+name+", "+value);
setCrit((prev)=>{
	return {...prev, [name]:value}
});
	
}//end func








function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func


function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

const location = useLocation();
console.log('location.pathname: '+location.pathname);
console.log('window.location: '+window.location);



      window.addEventListener("keypress", function (event) {
         // detect event key
         if (event.keyCode == 13) {
			 /*document.getElementById("btnlogin").click();*/
			 
         }
      });

/*
const deviceName = navigator?.userAgentData?.platform || navigator?.platform;
ReactGA.initialize(`${process.env.REACT_APP_GA_ID}`, {
	
	//getDeviceName()
  gaOptions: {
    device_name: deviceName,
    page_location: window.location.href,
  },
});

*/

     return (
		<>
<fieldset style={{width:"55%",marginLeft:"auto",marginRight:"auto", marginTop:"48px"}} >
<legend>TCI Customs - MSME Report</legend>
	<form id='form1' method='POST' onSubmit={ (e) => { submitform1(e); } }  >
	<table border="0" align='center' width='90%' >
	<tbody>
	<tr>
		<td align='right'  >Customs Procedure Code:</td>
		<td align='left'  >
			<select name='cpc' required value={crit.cpc}  onChange={(e)=>{handleChange(e);}} >
			<option value='' ></option>
			{msmecpcs}
			</select>
		</td>
	</tr>
	<tr>
		<td align='right'  >Start Date:</td>
		<td align='left'  ><input type='date' value={crit.date1} name="date1" onChange={(e)=>{handleChange(e);}} /></td>
	</tr>
	<tr>
		<td align='right'  >End Date:</td>
		<td align='left'  ><input type='date' value={crit.date2} name="date2" onChange={(e)=>{handleChange(e);}} /></td>
	</tr>

	
		  <tr>
		  <td align='right'  ></td>
		  <td align='left' className="inputcellpad" >
		  
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			
		  {!dowait.show && <button className="button" id="btnexcel"  >generate report</button> }
						
	
		  </td>
		  </tr>
		  <tr>
		  <td align='center' >&nbsp;</td>
		  </tr>
	</tbody>
	</table>
	</form>
	</fieldset>



<div align='center' style={{marginTop:"24px"}} >
<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault();toggleModalsm();}} >click to reset password</a>
</div>

<div align='center' id="snackbar" ></div>



<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div  id='modalsmtext' >
		Reset password feature is not ready as yet
		</div>
    </div>
</div>
	
	</>
);

}//end class

{
/*
onClick="document.getElementById('id01').style.display='none'"
onClick="document.getElementById('id01').style.display='none'"
*/
}

export default Msme; 

